import { ProtocolKey, USD_ZERO } from '@silo/types';
import { Rewards, UnstyledLink, useMobileNavContext } from '@silo/ui';
import { PATH } from 'app/hooks/useRoute';
import { useQueryRewardsData } from 'app/queries/use-query-rewards-data';

interface MobileRewardsTriggerProps {
  protocolKey: ProtocolKey;
}

export function MobileRewardsTrigger({ protocolKey }: MobileRewardsTriggerProps): JSX.Element | null {
  const { closeDialog } = useMobileNavContext();
  const { data } = useQueryRewardsData();

  const totalRewardsUsd = data?.data.totalRewardsUsd ?? USD_ZERO;

  if (totalRewardsUsd === 0n) {
    return null;
  }

  return (
    <UnstyledLink href={PATH.DASHBOARD} onClick={closeDialog} className={Rewards.trigger()}>
      <Rewards.TriggerContent protocolKey={protocolKey} totalRewardsUsd={totalRewardsUsd} />
    </UnstyledLink>
  );
}
